<template>
	<div class="modal-main">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'edit-modal',
};
</script>
<style lang="scss" scoped>
.modal-main {
	align-items: center;
	background-color: map-get($colors, transparent-black);
	display: flex;
	height: 100vh;
	justify-content: center;
	left: 0;
	overflow: auto;
	position: fixed;
	top: 0;
	width: 100vw;
	z-index: 160;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/edit-modal.vue